import { render, staticRenderFns } from "./culturalNewsadd.vue?vue&type=template&id=2952c4ee&scoped=true&"
import script from "./culturalNewsadd.vue?vue&type=script&lang=js&"
export * from "./culturalNewsadd.vue?vue&type=script&lang=js&"
import style0 from "./culturalNewsadd.vue?vue&type=style&index=0&id=2952c4ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952c4ee",
  null
  
)

component.options.__file = "culturalNewsadd.vue"
export default component.exports